import { Lock } from "lucide-react";

export default function SecureDataNotice({ className = "", testId = "secure-data-notice" }) {
  return (
    <div
      data-testid={testId}
      className={`flex items-center gap-3 rounded-lg border border-white/[0.08] bg-white/[0.035] px-3.5 py-3 ${className}`}
    >
      <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-emerald-400/20 bg-emerald-500/[0.08] text-emerald-300">
        <Lock className="h-4 w-4" aria-hidden="true" />
      </div>
      <div className="min-w-0">
        <p className="text-sm font-semibold tracking-tight text-zinc-100">256-bit SSL Encrypted</p>
        <p className="mt-0.5 text-xs leading-snug text-zinc-500">Your data is always secure</p>
      </div>
    </div>
  );
}
